import React, {Component} from 'react';
import * as echarts from 'echarts';
import moment from "moment";
import geo from '../json/xian.json'

class DataBuildsellbottom extends Component {
    constructor(props) {
        super(props);
        // 绘制图表
        let option = {
            backgroundColor:'rgba(128, 128, 128, 0)',
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            xAxis: {
                type: 'category',
                data: ['1月', '2月', '3月', '4月','5月', '6月', '7月', '8月','9月', '10月', '11月', '12月']
            },
            yAxis: {
                type: 'value',
                axisLabel:{
                    formatter:"{value}吨"
                }
            },
            legend: {
                data: [moment().format('YYYY')-1 + "年",moment().format('YYYY') + "年"]
            },
            series: [/*
                {
                    name: '2022年',
                    data: [],
                    type: 'line'
                },*/
                {
                    name: '2023年',
                    data: [],
                    type: 'line'
                },
            ]
        };
        this.state = {
            option: option,
            array: [],
            array2: []
        };
    }

    componentDidMount() {
        let start = moment().subtract(1, 'years').format('YYYY');
        let end = moment().format('YYYY');
        fetch("https://pd.pokemonbye.com:8081/api/getweightmonth?start="+start+"&end="+end)
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    this.setState({
                        isLoaded: true,
                        array: array
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
        let start1 = moment().format('YYYY');
        let end1 = moment().add(1, 'years').format('YYYY');
        fetch("https://pd.pokemonbye.com:8081/api/getweightmonth?start="+start1+"&end="+end1)
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    this.setState({
                        isLoaded: true,
                        array2: array
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        let option = this.state.option;
        let array = this.state.array;
        let array2 = this.state.array2;
        const data = [];
        const data2 = [];

        for (var i = 0; i < array.length; i++) {

            data.push(
                array[i].sum
            );
        }
        for (var i = 0; i < array2.length; i++) {

            data2.push(
                array2[i].sum
            );
        }
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(document.getElementById('datasellbottom'),'dark');
        //点击事件
        myChart.on('click', function (params) {
            //window.open('/list?area=' + encodeURIComponent(params.data.id), '_self');
        });
        myChart.setOption((option));
        option && myChart.setOption(option);
        myChart.setOption({
            series: [/*
                {
                    name: moment().format('YYYY')-1 + "年",
                    data: data,
                    type: 'line'
                },*/
                {
                    name: moment().format('YYYY') + "年",
                    data: data2,
                    type: 'line'
                },
            ]
        });
    }

    render() {
        return (
            <div id="datasellbottom" className="histogramlar"></div>
        )
    }
}

export default DataBuildsellbottom;
